<script setup lang="ts">
import type { SelectAreaProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SelectAreaProps>(), { modelValue: null })

type Emits = { (event: 'update:modelValue', value: string): string }
const emits = defineEmits<Emits>()

const storeIndex = useStoreIndex()

let areaItems = []

const makePrefList = () => {
  const masterArea = storeIndex.state.master.prefecture_area
  if (masterArea && masterArea.details) {
    const area = masterArea.details
    const newList = []
    newList.push({
      title: '全国',
      value: null,
      area: true,
    })

    for (let i = 0; i < area.length; i++) {
      newList.push({
        title: area[i].text,
        value: 'area-' + area[i].id,
        area: true,
      })
      const prefs = area[i].value.split(',')
      for (let p = 0; p < prefs.length; p++) {
        newList.push({
          title: storeIndex.getPrefName(prefs[p]),
          value: 'pref-' + prefs[p],
          area: false,
        })
      }
    }
    areaItems = newList
  }
}
makePrefList()

const innerValue = computed({
  get: () => {
    return props.modelValue
  },
  set: (val) => {
    if (props.modelValue !== val) {
      emits('update:modelValue', val)
    }
  },
})
</script>

<template>
  <div class="c-selectArea">
    <v-select
      v-model="innerValue"
      class="c-searchControl"
      v-bind:items="areaItems"
      label="地域"
      single-line
      hide-details
      variant="underlined"
      density="comfortable"
    >
      <template v-slot:item="selectItem">
        <v-list-item
          v-bind="selectItem.props"
          v-bind:style="{ backgroundColor: selectItem.item.raw.area ? '#f8f8f8' : '' }"
        >
          <template v-slot:title="titleItem">
            <v-list-item-title
              v-bind:style="{
                fontWeight: selectItem.item.raw.area ? 'bold' : 'normal',
              }"
            >
              {{ titleItem.title }}
            </v-list-item-title>
          </template>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<style lang="scss" scoped>
.c-selectArea {
  :deep(.v-list-item) {
    &.is-area {
      background-color: #f8f8f8 !important;

      .v-list-item-title {
        font-weight: bold !important;
      }
    }
  }
}
</style>
